var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconDiscount = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1923 -1279)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M617.207,176.207l-9,9a1,1,0,0,1-1.414-1.414l9-9a1,1,0,0,1,1.414,1.414ZM619,184a3,3,0,1,1-3-3A3,3,0,0,1,619,184Zm-2,0a1,1,0,1,0-1,1A1,1,0,0,0,617,184Zm-9-5a3,3,0,1,1,3-3A3,3,0,0,1,608,179Zm0-2a1,1,0,1,0-1-1A1,1,0,0,0,608,177Z",
  transform: "translate(1323 1111)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDiscount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-discount.d78b5374.svg";
export { ForwardRef as ReactComponent };